/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Payment_HistoryInputs */

const vi_report_debt_payment_history = /** @type {(inputs: Report_Debt_Payment_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử thanh toán`)
};

/**

* @param {Report_Debt_Payment_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_payment_history = /** @type {((inputs?: Report_Debt_Payment_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Payment_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_payment_history(inputs)
});